import { Settings } from 'react-slick';

import { TABLET_MIN_WIDTH } from '../../utils';

export const MAX_VISIBLE_BAGGAGE_COLUMNS = 5;

export const baggageColumnsSliderSettings: Settings = {
	speed: 250,
	swipe: false,
	infinite: false,
	slidesToShow: MAX_VISIBLE_BAGGAGE_COLUMNS,
	slidesToScroll: 1,
	responsive: [
		{
			breakpoint: TABLET_MIN_WIDTH,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1
			}
		}
	]
};
